'use client';
import React from 'react';
import { AccountButton as SharedAccountButton } from '@launchstore/shared-puck';
import type { AccountButtonProps, AccountCheckAuth } from '@launchstore/shared-puck';

const SharedAccountButtonRender = (SharedAccountButton as any).render;

const AccountButtonImpl: React.FC<AccountButtonProps> = (props: any) => {
  const checkAuth: AccountCheckAuth = async () => {
    try {
      const res = await fetch('/api/auth/check', { credentials: 'include' });
      if (!res.ok) return { authenticated: false };
      const data = await res.json();
      return { authenticated: !!data.authenticated, customer: data.customer || null };
    } catch {
      return { authenticated: false };
    }
  };
  return <SharedAccountButtonRender {...(props as any)} checkAuth={checkAuth} />;
};

export const AccountButton: any = { ...SharedAccountButton, render: (props: any) => <AccountButtonImpl {...props} /> };
export default AccountButton;
